import React from 'react';
import { connect } from 'react-redux';
import { setCliqSubMidInfo, toggleCliqSubMidInfoPopup, setPaymentGatewayInfo } from "../../Account/AccountActions";
import { createFabricatorSubMidId } from "../../AddNewEntity/AddNewEntityActions";

class CliqSubMidInfoPopup extends React.Component {

  closePopup = () => {
    this.props.toggleCliqSubMidInfoPopup(false)
  };

  createFabricatorSubMidId = () => {
    const { entityId } = this.props.accountPageInfo;

    const { cliqSubMid_CompanyName,
      cliqSubMid_ContactName,
      cliqSubMid_CorporateState,
      cliqSubMid_CorporateType,
      cliqSubMid_AverageTicket,
      cliqSubMid_FundingFrequency,
      cliqSubMid_IncorporateDate,
      cliqSubMid_Industry,
      cliqSubMid_MonthlyVolume,
      cliqSubMid_PhoneNumber,
      cliqSubMid_TaxId,
      cliqSubMid_AccountNumber,
      cliqSubMid_RoutingNumber,
      cliqSubMid_Address_Address1,
      cliqSubMid_Address_Address2,
      cliqSubMid_Address_CityTown,
      cliqSubMid_Address_CountryCode,
      cliqSubMid_Address_PostalCode,
      cliqSubMid_Address_StateProvince,
      cliqSubMid_Owners_DOB,
      cliqSubMid_Owners_Email,
      cliqSubMid_Owners_FirstName,
      cliqSubMid_Owners_FullName,
      cliqSubMid_Owners_LastName,
      cliqSubMid_Owners_MiddleName,
      cliqSubMid_Owners_PhoneNumber,
      cliqSubMid_Owners_DriverLicenseNumber,
      cliqSubMid_Owners_DriverLicenseState,
      cliqSubMid_Owners_SSN,
      cliqSubMid_Owners_OwnershipPercentage,
      cliqSubMid_Owners_Address_Address1,
      cliqSubMid_Owners_Address_Address2,
      cliqSubMid_Owners_Address_CityTown,
      cliqSubMid_Owners_Address_CountryCode,
      cliqSubMid_Owners_Address_PostalCode,
      cliqSubMid_Owners_Address_StateProvince } = this.props.cliqSubMidInfo;


    const cliqSubMidData = {
      companyName: cliqSubMid_CompanyName,
      contactName: cliqSubMid_ContactName,
      corporateState: cliqSubMid_CorporateState,
      CorporateType: cliqSubMid_CorporateType,
      averageTicket: cliqSubMid_AverageTicket,
      fundingFrequency: cliqSubMid_FundingFrequency,
      incorporateDate: cliqSubMid_IncorporateDate,
      industry: cliqSubMid_Industry,
      monthlyVolume: cliqSubMid_MonthlyVolume,
      phoneNumber: cliqSubMid_PhoneNumber,
      taxId: cliqSubMid_TaxId,
      accountNumber: cliqSubMid_AccountNumber,
      routingNumber: cliqSubMid_RoutingNumber,
      address: {
        address1: cliqSubMid_Address_Address1,
        address2: cliqSubMid_Address_Address2,
        cityTown: cliqSubMid_Address_CityTown,
        countryCode: cliqSubMid_Address_CountryCode,
        postalCode: cliqSubMid_Address_PostalCode,
        stateProvince: cliqSubMid_Address_StateProvince,
      },
      owners: [{
        dob: cliqSubMid_Owners_DOB,
        email: cliqSubMid_Owners_Email,
        firstName: cliqSubMid_Owners_FirstName,
        fullName: cliqSubMid_Owners_FullName,
        lastName: cliqSubMid_Owners_LastName,
        middleName: cliqSubMid_Owners_MiddleName,
        phoneNumber: cliqSubMid_Owners_PhoneNumber,
        driverLicenseNumber: cliqSubMid_Owners_DriverLicenseNumber,
        driverLicenseState: cliqSubMid_Owners_DriverLicenseState,
        ssn: cliqSubMid_Owners_SSN,
        ownershipPercentage: cliqSubMid_Owners_OwnershipPercentage,
        address: {
          address1: cliqSubMid_Owners_Address_Address1,
          address2: cliqSubMid_Owners_Address_Address2,
          cityTown: cliqSubMid_Owners_Address_CityTown,
          countryCode: cliqSubMid_Owners_Address_CountryCode,
          postalCode: cliqSubMid_Owners_Address_PostalCode,
          stateProvince: cliqSubMid_Owners_Address_StateProvince,
        }
      }]
    }

    this.props.createFabricatorSubMidId(entityId, cliqSubMidData).then((res) => { this.props.setPaymentGatewayInfo({ paymentGateway_Cliq_FabricatorSubMid: res }); this.closePopup(); });
  }

  renderStoreSubMIDIdList(storeSubMidIds) {

  }

  renderOwnerFields(values) {
    const { cliqSubMid_Owners_DOB,
      cliqSubMid_Owners_Email,
      cliqSubMid_Owners_FirstName,
      cliqSubMid_Owners_FullName,
      cliqSubMid_Owners_LastName,
      cliqSubMid_Owners_MiddleName,
      cliqSubMid_Owners_PhoneNumber,
      cliqSubMid_Owners_DriverLicenseNumber,
      cliqSubMid_Owners_DriverLicenseState,
      cliqSubMid_Owners_SSN,
      cliqSubMid_Owners_OwnershipPercentage,
      cliqSubMid_Owners_Address_Address1,
      cliqSubMid_Owners_Address_Address2,
      cliqSubMid_Owners_Address_CityTown,
      cliqSubMid_Owners_Address_CountryCode,
      cliqSubMid_Owners_Address_PostalCode,
      cliqSubMid_Owners_Address_StateProvince } = values;

    return <div>

      <label>Full Name</label>
      <input type="text" value={cliqSubMid_Owners_FullName} placeholder="Full Name"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_FullName: e.target.value })} />

      <label>First Name</label>
      <input type="text" value={cliqSubMid_Owners_FirstName} placeholder="First Name"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_FirstName: e.target.value })} />

      <label>Last Name</label>
      <input type="text" value={cliqSubMid_Owners_LastName} placeholder="Last Name"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_LastName: e.target.value })} />

      <label>Middle Name</label>
      <input type="text" value={cliqSubMid_Owners_MiddleName} placeholder="Middle Name"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_MiddleName: e.target.value })} />

      <label>Date of Birth</label>
      <input type="text" value={cliqSubMid_Owners_DOB} placeholder="Date of Birth"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_DOB: e.target.value })} />

      <label>Email</label>
      <input type="text" value={cliqSubMid_Owners_Email} placeholder="Email"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Email: e.target.value })} />

      <label>Phone</label>
      <input type="text" value={cliqSubMid_Owners_PhoneNumber} placeholder="Phone"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_PhoneNumber: e.target.value })} />

      <label>Driver License Number</label>
      <input type="text" value={cliqSubMid_Owners_DriverLicenseNumber} placeholder="Driver License Number"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_DriverLicenseNumber: e.target.value })} />

      <label>Driver License State</label>
      <input type="text" value={cliqSubMid_Owners_DriverLicenseState} placeholder="Driver License State"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_DriverLicenseState: e.target.value })} />

      <label>SSN</label>
      <input type="text" value={cliqSubMid_Owners_SSN} placeholder="SSN"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_SSN: e.target.value })} />

      <label>Ownership Percentage</label>
      <input type="text" value={cliqSubMid_Owners_OwnershipPercentage} placeholder="Ownership Percentage"
        onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_OwnershipPercentage: e.target.value })} />

      <label>Owner Address</label>
      <div>
        <label>Address 1</label>
        <input type="text" value={cliqSubMid_Owners_Address_Address1} placeholder="Address 1"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_Address1: e.target.value })} />
        <label>Address 2</label>
        <input type="text" value={cliqSubMid_Owners_Address_Address2} placeholder="Address 2"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_Address2: e.target.value })} />
        <label>City Town</label>
        <input type="text" value={cliqSubMid_Owners_Address_CityTown} placeholder="CityTown"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_CityTown: e.target.value })} />
        <label>Country Code</label>
        <input type="text" value={cliqSubMid_Owners_Address_CountryCode} maxLength={2} placeholder="CountryCode"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_CountryCode: e.target.value })} />
        <label>State Province</label>
        <input type="text" value={cliqSubMid_Owners_Address_StateProvince} placeholder="State Province"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_StateProvince: e.target.value })} />
        <label>Postal Code</label>
        <input type="text" value={cliqSubMid_Owners_Address_PostalCode} placeholder="Postal Code"
          onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Owners_Address_PostalCode: e.target.value })} />

      </div>
    </div>;
  }

  render() {
    const { cliqSubMid_CompanyName,
      cliqSubMid_ContactName,
      cliqSubMid_CorporateState,
      cliqSubMid_CorporateType,
      cliqSubMid_AverageTicket,
      cliqSubMid_FundingFrequency,
      cliqSubMid_IncorporateDate,
      cliqSubMid_Industry,
      cliqSubMid_MonthlyVolume,
      cliqSubMid_PhoneNumber,
      cliqSubMid_TaxId,
      cliqSubMid_AccountNumber,
      cliqSubMid_RoutingNumber,
      cliqSubMid_Address_Address1,
      cliqSubMid_Address_Address2,
      cliqSubMid_Address_CityTown,
      cliqSubMid_Address_CountryCode,
      cliqSubMid_Address_PostalCode,
      cliqSubMid_Address_StateProvince,
      cliqSubMid_Owners_DOB,
      cliqSubMid_Owners_Email,
      cliqSubMid_Owners_FirstName,
      cliqSubMid_Owners_FullName,
      cliqSubMid_Owners_LastName,
      cliqSubMid_Owners_MiddleName,
      cliqSubMid_Owners_PhoneNumber,
      cliqSubMid_Owners_DriverLicenseNumber,
      cliqSubMid_Owners_DriverLicenseState,
      cliqSubMid_Owners_SSN,
      cliqSubMid_Owners_OwnershipPercentage,
      cliqSubMid_Owners_Address_Address1,
      cliqSubMid_Owners_Address_Address2,
      cliqSubMid_Owners_Address_CityTown,
      cliqSubMid_Owners_Address_CountryCode,
      cliqSubMid_Owners_Address_PostalCode,
      cliqSubMid_Owners_Address_StateProvince } = this.props.cliqSubMidInfo;


    return (
      <div className="ui-popup ui-popup--large">
        <div className="ui-popup-header">
          <span className="ui-popup-header__text">Cliq SubMid info</span>
          <button className="ui-popup-header__close" onClick={this.closePopup} />
        </div>
        <div className="ui-popup-body ui-popup-body--tiny">
          <div className='manage-payment-gateways--gateway'>
            <label>Company Name</label>
            <input type="text" value={cliqSubMid_CompanyName} placeholder="Company Name"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_CompanyName: e.target.value })} />
            <label>Contact Name</label>
            <input type="text" value={cliqSubMid_ContactName} placeholder="Contact Name"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_ContactName: e.target.value })} />
            <label>Corporate State</label>
            <input type="text" value={cliqSubMid_CorporateState} placeholder="Corporate State"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_CorporateState: e.target.value })} />
            <label>Corporate Type</label>
            <input type="text" value={cliqSubMid_CorporateType} placeholder="Corporate Type"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_CorporateType: e.target.value })} />
            <label>Average Ticket</label>
            <input type="text" value={cliqSubMid_AverageTicket} placeholder="Average Ticket"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_AverageTicket: e.target.value })} />
            <label>Funding Frequency</label>
            <input type="text" value={cliqSubMid_FundingFrequency} placeholder="Funding Frequency"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_FundingFrequency: e.target.value })} />
            <label>Incorporate Date</label>
            <input type="text" value={cliqSubMid_IncorporateDate} placeholder="Incorporate Date"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_IncorporateDate: e.target.value })} />
            <label>Industry</label>
            <input type="text" value={cliqSubMid_Industry} placeholder="Industry"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Industry: e.target.value })} />
            <label>Monthly Volume</label>
            <input type="text" value={cliqSubMid_MonthlyVolume} placeholder="Monthly Volume"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_MonthlyVolume: e.target.value })} />
            <label>Phone Number</label>
            <input type="text" value={cliqSubMid_PhoneNumber} placeholder="Phone Number"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_PhoneNumber: e.target.value })} />
            <label>Tax Id</label>
            <input type="text" value={cliqSubMid_TaxId} placeholder="Tax Id"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_TaxId: e.target.value })} />
            <label>Bank Account Number</label>
            <input type="text" value={cliqSubMid_AccountNumber} placeholder="Account Number"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_AccountNumber: e.target.value })} />
            <label>Bank Routing Number</label>
            <input type="text" value={cliqSubMid_RoutingNumber} placeholder="Routing Number"
              onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_RoutingNumber: e.target.value })} />

            <label>Company Address</label>
            <div>
              <label>Address 1</label>
              <input type="text" value={cliqSubMid_Address_Address1} placeholder="Address 1"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_Address1: e.target.value })} />
              <label>Address 2</label>
              <input type="text" value={cliqSubMid_Address_Address2} placeholder="Address 2"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_Address2: e.target.value })} />
              <label>City Town</label>
              <input type="text" value={cliqSubMid_Address_CityTown} placeholder="CityTown"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_CityTown: e.target.value })} />
              <label>Country Code</label>
              <input type="text" value={cliqSubMid_Address_CountryCode} maxLength={2} placeholder="CountryCode"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_CountryCode: e.target.value })} />
              <label>State Province</label>
              <input type="text" value={cliqSubMid_Address_StateProvince} placeholder="State Province"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_StateProvince: e.target.value })} />
              <label>Postal Code</label>
              <input type="text" value={cliqSubMid_Address_PostalCode} placeholder="Postal Code"
                onChange={(e) => this.props.setCliqSubMidInfo({ cliqSubMid_Address_PostalCode: e.target.value })} />

            </div>
            <label>Owner Details</label>
            {this.renderOwnerFields({
              cliqSubMid_Owners_DOB,
              cliqSubMid_Owners_Email,
              cliqSubMid_Owners_FirstName,
              cliqSubMid_Owners_FullName,
              cliqSubMid_Owners_LastName,
              cliqSubMid_Owners_MiddleName,
              cliqSubMid_Owners_PhoneNumber,
              cliqSubMid_Owners_DriverLicenseNumber,
              cliqSubMid_Owners_DriverLicenseState,
              cliqSubMid_Owners_SSN,
              cliqSubMid_Owners_OwnershipPercentage,
              cliqSubMid_Owners_Address_Address1,
              cliqSubMid_Owners_Address_Address2,
              cliqSubMid_Owners_Address_CityTown,
              cliqSubMid_Owners_Address_CountryCode,
              cliqSubMid_Owners_Address_PostalCode,
              cliqSubMid_Owners_Address_StateProvince
            })}

          </div>
        </div>
        <div className="ui-popup-footer">
          <button className="ui-button ui-button--blue" onClick={this.closePopup}>
            <span className="ui-button-text ui-button--uppercase">Cancel</span>
          </button>
          <button className="ui-button ui-button--green" onClick={this.createFabricatorSubMidId}>
            <span className="ui-button-text ui-button--uppercase">Request</span>
          </button>
        </div>
      </div>
    )
  }

}

const mapStateToProps = (store) => {
  return {
    cliqSubMidInfo: store.accountState.cliqSubMidInfo,
    accountPageInfo: store.accountState.accountPageInfo
  };
};

const mapDispatchToProps = {
  createFabricatorSubMidId,
  toggleCliqSubMidInfoPopup,
  setCliqSubMidInfo,
  setPaymentGatewayInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(CliqSubMidInfoPopup);
